import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Design system — imported verbatim from the prototype. Order matters:
// tokens/fonts first, then component styles.
import "./styles/colors_and_type.css";
import "./styles/styles.css";
import "./styles/mobile.css";

import App from "./App.jsx";
import Continue from "./pages/Continue.jsx";
import Admin from "./pages/Admin.jsx";
import Staff from "./pages/Staff.jsx";

// Optional Sentry error tracking (§7b-3) — loaded only when a DSN is configured,
// so it adds nothing to the default bundle/runtime.
if (import.meta.env.VITE_SENTRY_DSN) {
  import("@sentry/react").then((Sentry) => {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.MODE,
      tracesSampleRate: 0,
    });
  }).catch(() => { /* never block app boot on telemetry */ });
}

// Register the PWA service worker (installability + offline shell). Prod only —
// avoids cache interference during dev. Never blocks app boot.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").then((reg) => {
      // Pull the latest SW on every load and whenever the tab regains focus, so a
      // long-lived/installed client doesn't keep running a stale bundle after a deploy.
      reg.update().catch(() => {});
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") reg.update().catch(() => {});
      });
    }).catch(() => { /* non-fatal */ });
  });
  // When a new SW takes control, reload once so the page runs the fresh bundle.
  let _reloaded = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (_reloaded) return;
    _reloaded = true;
    window.location.reload();
  });
}

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/continue" element={<Continue />} />
        <Route path="/admin/*" element={<Admin />} />
        {/* Agent Services portal — its own role, not the admin panel. */}
        <Route path="/staff/*" element={<Staff />} />
        <Route path="/*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
